export enum AwsException {
  LIMIT_EXCEEDED_EXCEPTION = "LimitExceededException",
  INVALID_PARAMETER_EXCEPTION = "InvalidParameterException",
  USERNAME_EXISTS_EXCEPTION = "UsernameExistsException",
  USER_NOT_CONFIRMED_EXCEPTION = "UserNotConfirmedException",
  USER_NOT_FOUND_EXCEPTION = "UserNotFoundException",
  NOT_AUTHORIZED_EXCEPTION = "NotAuthorizedException",
  EXPIRED_CODE_EXCEPTION = "ExpiredCodeException",
}
